import React, { useState, ComponentType, useEffect, useCallback, useRef } from "react";
import { DatePicker, Table, SelectProps, Form, message, Modal, notification, Progress, Input } from "antd";
import type { DatePickerProps, TableColumnsType, TableProps } from "antd";
import { FormInstance } from "antd/es/form";
import moment from "moment";
import { useAuth } from "../context/AuthContext";
require('moment/locale/id');
moment.locale('id');

function StartLicense(stimulsoftInstance: any) {
    const key = process.env.REACT_APP_STIMULSOFT_LICENSE_KEY;
    if (key && key.trim() !== "") {
        try {
            stimulsoftInstance.Base.StiLicense.key = key.trim();
        } catch (error: any) { }
    } else {
        const hardcodedKey = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHmKmIYtQbGVffUafn4grxXukjNz+mLI/d2lO8A9DuHxAxu4MmrN4lqhtklB0Pcnfq+AIk+1s6kU0D6JIIxpfQs1FV6pzwrzAWDLexRPvVgpswR/C5n69gFjFmWmtV0bGCTAj6H/MHgwElWYT9nYccmuFH0sfAj7VELa2HehqREJ7di+05AWeWIScfcWsf0XZ3JK+2X3reYvhUEAxrCwX3FDw2p1hPQIfiUVkUd4NRvfwWBLOjP2ZTfp9dzNe1D6T7miK1VBd731o/ex6q1bkdNH+G1KV6OLxdQwb9zWr4AR0QtMKwrphskgAYb5PMCectoVCeRFKtWSm8qnMP+GN8v0GHbJGQ/ZYWMAsE94nCEhnJz9T/xfy1b6WEWqpUUjVsfPzm/naRz0bxVN+AtFW7thTBMwGXoKTJXnKhfrI5u/fRffUu78ejnazBjWCHANN/xF7XOLhnFWw5JZHPXkaoCbiG8kBL3bgL4DtSyZ7jecAPmJUtainwLNMdo75J6hvu/pS+jDUs2tqRjEv6PTehXg";
        try {
            stimulsoftInstance.Base.StiLicense.key = hardcodedKey;
        } catch (fallbackError: any) { }
    }
}

export interface BrandOption {
    value: string;
    label: string;
}

export interface PackingListItem {
    key: React.Key;
    item_code: string;
    item_name: string;
    qty: number;
    uom: string;
    price: number;
    disc_percent: number;
    discount: number;
    total: number;
    chassis_no: string;
    status_part?: string;
    hpp?: string;
    ppn?: number;
}

export interface DataType {
    key: React.Key;
    item_code: string;
    item_name: string;
    qty: number;
    uom: string;
    price: number;
    disc_percent: number;
    discount: number;
    total: number;
    chassis_no: string;
    status_part?: string;
    invoice_return_no?: string;
    hpp?: string;
    ppn?: number;
}

export interface TermsOfPaymentOption {
    value: string;
    label: string;
}

export interface VatTransactionOption {
    value: string;
    label: string;
}

export interface ProvinceOption {
    value: string;
    label: string;
}

export interface RegencyOption {
    value: string;
    label: string;
}

export interface KecamatanOption {
    value: string;
    label: string;
}

export interface KelurahanOption {
    value: string;
    label: string;
}

export interface CustomerDataType {
    key: string;
    cs_code: string;
    cs_name: string;
    customer_type: string;
    address_line1: string;
    address_line2: string;
    no_hp1: string;
    title_p?: string;
    title_s?: string;
    id_type?: string;
    id_no?: string;
    vatprovinsi?: string;
    vatkabupaten?: string;
    vatkelurahan?: string;
    vatkecamatan?: string;
    vatkodepos?: string;
    vatnpwp?: string;
    vatnpwpdate?: string;
    vatpkp?: string;
    vatpkpdate?: string;
    vattransactioncode?: string;
    vatname?: string;
    vat_address1?: string;
    vat_address2?: string;
}

export interface PackingListData {
    trans_id?: string;
    key: number;
    packing_list_no: string;
    packing_list_date: string;
    sales_order_no: string;
    sales_order_date: string;
    profit_center?: string;
    dealer_re_code?: string;
    dealer_re_code_label?: string;
    transaction_type?: string;
    event_no?: string;
    customer?: string;
    sales_man?: string;
    po_customer_no?: string;
    payment_type?: string;
    customer_code?: string;
    customer_type?: string;
    title_prefix?: string;
    name_bill?: string;
    title_suffix?: string;
    id_type?: string;
    id_no?: string;
    billable_to?: string;
    address?: string;
    provinsi?: string;
    kabupaten?: string;
    kecamatan?: string;
    kelurahan?: string;
    postal_code?: string;
    phone_no?: string;
    top?: string;
    bill_code?: string;
    tax_invoice_type?: string;
    npwp?: string;
    npwp_date?: string;
    pkp?: string;
    pkp_date?: string;
    transaction_code?: string;
    name_tax?: string;
    address_tax?: string;
    items?: PackingListItem[];
}

export interface InvoiceDetailsData {
    trans_id?: string;
    status: number | string;
    invoice_no: string;
    invoice_date: string;
    invoice_due_date: string;
    tax_invoice_no: string;
    tax_invoice_date: string;
    brand: string;
    vat_item_category: string;
    packing_list_no: string;
    profit_center: string;
    dealer_re_code: string;
    dealer_re_code_label?: string;
    transaction_type: string;
    event_no: string;
    credit_note: string;
    customer: string;
    sales_order_no: string;
    sales_man: string;
    po_customer_no: string;
    bank1: string;
    bank2: string;
    payment_type: string;
    remark: string;
    customer_code: string;
    customer_type: string;
    title_prefix: string;
    name_bill: string;
    title_suffix: string;
    id_type: string;
    id_no: string;
    billable_to: string;
    address: string;
    provinsi: string;
    kabupaten: string;
    kecamatan: string;
    kelurahan: string;
    kode_pos: string;
    phone_no: string;
    fax_no: string;
    top: string;
    bill_code: string;
    tax_invoice_type: string;
    pkp_type: string;
    pkp: string;
    pkp_date: string;
    transaction_code: string;
    name_tax: string;
    address_tax: string;
    item_total: number;
    item_discount: number;
    total: number;
    dp: number;
    vat: number;
    invoice_amount: number;
    npwp: string;
    npwp_date: string;
    sales_date: string;
    top_description: string;
}

export interface SalesOrderInvoiceLogicProps {
    transformStyle: React.CSSProperties;
    showContentBillTo: boolean;
    setShowContentBillTo: React.Dispatch<React.SetStateAction<boolean>>;
    showContentTotal: boolean;
    setShowContentTotal: React.Dispatch<React.SetStateAction<boolean>>;
    showContentTax: boolean;
    setShowContentTax: React.Dispatch<React.SetStateAction<boolean>>;
    checkedValue: string | null;
    handleCheckboxChange: (value: string) => void;
    onDateChange: DatePickerProps['onChange'];
    onChange: (value: string) => void;
    onChangeProvince: (value: string) => void;
    onChangeVatItemCategory: (value: string) => void;
    columns: TableColumnsType<DataType>;
    rowSelection: TableProps<DataType>["rowSelection"];
    dataSource: DataType[];
    termsOfPaymentOptions: TermsOfPaymentOption[];
    loadingTermsOfPayment: boolean;
    brandOptions: BrandOption[];
    loadingBrands: boolean;
    vatTransactionOptions: VatTransactionOption[];
    loadingVatTransactions: boolean;
    showPackingListModal: boolean;
    setShowPackingListModal: React.Dispatch<React.SetStateAction<boolean>>;
    showCustomerModal: boolean;
    setShowCustomerModal: React.Dispatch<React.SetStateAction<boolean>>;
    provinceOptions: ProvinceOption[];
    loadingProvinces: boolean;
    regencyOptions: RegencyOption[];
    loadingRegencies: boolean;
    selectedProvinceCode: string | undefined;
    kecamatanOptions: KecamatanOption[];
    loadingKecamatans: boolean;
    selectedRegencyCode: string | undefined;
    onChangeRegency: (value: string) => void;
    kelurahanOptions: KelurahanOption[];
    loadingKelurahans: boolean;
    selectedKecamatanCode: string | undefined;
    onChangeKecamatan: (value: string) => void;
    postalCode: string;
    onChangeKelurahan: (value: string) => void;
    form: FormInstance;
    onSelectCustomer: (customer: CustomerDataType) => void;
    onSelectPackingList: (data: PackingListData, items: PackingListItem[]) => void;
    onChangeTermsOfPayment: (value: string) => void;
    isPackingListNoDisabled: boolean;
    isPackingListNoReadOnly: boolean;
    isSearchPLButtonDisabled: boolean;
    isVoidDisabled: boolean;
    autosaveStatus: 'idle' | 'processing' | 'error' | 'stopped';
    onVoid: () => void;
    setVoidReason: React.Dispatch<React.SetStateAction<string>>;
    voidReason: string;
    isReasonModalOpen: boolean;
    setIsReasonModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleReasonSubmit: () => void;
    onSubmit: () => void;
    onPrint: () => void;
    isPrinting: boolean
    isProcessing: boolean;
    dealerReCodeDisplay: string;
    isFormDisabled: boolean;
    onNew: () => void;
    onRefreshData: () => void;
    isPrintDisabled: boolean;
    isReportModalOpen: boolean;
    handleReportModalCancel: () => void;
}

const transformStyle = {
    transform: "scale(0.80)",
    transformOrigin: "top left",
    width: "125%",
};

const columns: TableColumnsType<DataType> = [
    {
        title: "Item Code",
        dataIndex: "item_code",
    },
    {
        title: "Item Name",
        dataIndex: "item_name",
    },
    {
        title: "Qty",
        dataIndex: "qty",
    },
    {
        title: "UOM",
        dataIndex: "uom",
    },
    {
        title: "Price",
        dataIndex: "price",
        render: (text: number) => new Intl.NumberFormat('id-ID', { style: 'decimal' }).format(text),
    },
    {
        title: "Disc %",
        dataIndex: "disc_percent",
        render: (text: number) => new Intl.NumberFormat('id-ID', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(text) || 0),
    },
    {
        title: "Discount",
        dataIndex: "discount",
        render: (text: number) => new Intl.NumberFormat('id-ID', { style: 'decimal' }).format(text),
    },
    {
        title: "Total",
        dataIndex: "total",
        render: (text: number) => new Intl.NumberFormat('id-ID', { style: 'decimal' }).format(text),
    },
    {
        title: "Chassis No",
        dataIndex: "chassis_no",
    },
    {
        title: "Invoice Return No",
        dataIndex: "invoice_return_no",
    },
];

function debounce<T extends (...args: any[]) => void>(func: T, delay: number): T {
    let timeout: NodeJS.Timeout;
    return ((...args: any[]) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), delay);
    }) as T;
}

export const STATUS_LIST = [
    { id: 1, label: 'Draft' },
    { id: 2, label: 'Active' },
    { id: 3, label: 'Waiting for Approved' },
    { id: 4, label: 'Complete' },
    { id: 5, label: 'Cancel' },
    { id: 6, label: 'Closed' }
];

export const convertStatusToNumber = (statusStr: string | number): number | string => {
    const match = STATUS_LIST.find(s => s.label === statusStr);
    return match ? match.id : statusStr;
};

export const convertStatusToString = (statusNum: number | string): string => {
    const match = STATUS_LIST.find(s => String(s.id) === String(statusNum));
    return match ? match.label : String(statusNum);
};

const units = ["", "satu", "dua", "tiga", "empat", "lima", "enam", "tujuh", "delapan", "sembilan"];
const teens = ["sepuluh", "sebelas", "dua belas", "tiga belas", "empat belas", "lima belas", "enam belas", "tujuh belas", "delapan belas", "sembilan belas"];
const tens = ["", "", "dua puluh", "tiga puluh", "empat puluh", "lima puluh", "enam puluh", "tujuh puluh", "delapan puluh", "sembilan puluh"];
const scales = ["", "ribu", "juta", "miliar", "triliun"];

const convertLessThanOneThousand = (n: number): string => {
    let result = "";
    if (n >= 100) {
        if (Math.floor(n / 100) === 1) {
            result += "seratus";
        } else {
            result += units[Math.floor(n / 100)] + " ratus";
        }
        n %= 100;
        if (n > 0) result += " ";
    }
    if (n >= 10 && n < 20) {
        result += teens[n - 10];
        n = 0;
    } else if (n >= 20) {
        result += tens[Math.floor(n / 10)];
        n %= 10;
        if (n > 0) result += " ";
    }
    if (n > 0) {
        result += units[n];
    }
    return result.trim();
};

const numberToWordsID = (num: number): string => {
    if (num === 0) return "Nol";
    let integerPart = Math.round(num);
    let words = "";
    let i = 0;

    if (integerPart === 0) {
        words = "Nol";
    } else {
        while (integerPart > 0) {
            const chunk = integerPart % 1000;
            if (chunk !== 0) {
                let chunkWords = convertLessThanOneThousand(chunk);

                if (i === 1 && chunk === 1) {
                    words = "seribu" + (words ? " " + words : "");
                } else {

                    words = chunkWords + (scales[i] ? " " + scales[i] : "") + (words ? " " + words : "");
                }
            }
            integerPart = Math.floor(integerPart / 1000);
            i++;
        }
    }

    words = words.trim();
    let finalWords = words;

    const toTitleCase = (str: string): string => str.split(" ").filter(w => w.length > 0).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
    return toTitleCase(finalWords + " rupiah");
};

const formatToIndonesianDate = (dateStr: string | null | undefined): string => {
    if (!dateStr) return "";
    const normalized = dateStr.replace(/\//g, "-");
    const parsed = moment(normalized, ["YYYY-MM-DD", "YYYY-M-D", "DD-MM-YYYY", "D-M-YYYY", "DD MMMM YYYY", "D MMMM YYYY"]);
    return parsed.isValid() ? parsed.format("D MMMM YYYY") : dateStr;
};

const withSalesOrderInvoiceLogic = <P extends SalesOrderInvoiceLogicProps>(
    WrappedComponent: ComponentType<P>
) => {
    const HOCComponent: React.FC<Omit<P, keyof SalesOrderInvoiceLogicProps>> = (props) => {

        const [form] = Form.useForm();
        const { userData } = useAuth();
        const [isReasonModalOpen, setIsReasonModalOpen] = useState(false);
        const [voidReason, setVoidReason] = useState("Void Invoice");
        const [showContentBillTo, setShowContentBillTo] = useState(false);
        const [showContentTotal, setShowContentTotal] = useState(false);
        const [showContentTax, setShowContentTax] = useState(false);
        const [checkedValue, setCheckedValue] = useState<string | null>(null);
        const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
        const [termsOfPaymentOptions, setTermsOfPaymentOptions] = useState<TermsOfPaymentOption[]>([]);
        const [loadingTermsOfPayment, setLoadingTermsOfPayment] = useState(false);
        const [brandOptions, setBrandOptions] = useState<BrandOption[]>([]);
        const [loadingBrands, setLoadingBrands] = useState(false);
        const [vatTransactionOptions, setVatTransactionOptions] = useState<VatTransactionOption[]>([]);
        const [loadingVatTransactions, setLoadingVatTransactions] = useState(false);
        const [showPackingListModal, setShowPackingListModal] = useState(false);
        const [showCustomerModal, setShowCustomerModal] = useState(false);
        const [provinceOptions, setProvinceOptions] = useState<ProvinceOption[]>([]);
        const [loadingProvinces, setLoadingProvinces] = useState(false);
        const [regencyOptions, setRegencyOptions] = useState<RegencyOption[]>([]);
        const [loadingRegencies, setLoadingRegencies] = useState(false);
        const [selectedProvinceCode, setSelectedProvinceCode] = useState<string | undefined>(undefined);
        const [kecamatanOptions, setKecamatanOptions] = useState<KecamatanOption[]>([]);
        const [loadingKecamatans, setLoadingKecamatans] = useState(false);
        const [selectedRegencyCode, setSelectedRegencyCode] = useState<string | undefined>(undefined);
        const [kelurahanOptions, setKelurahanOptions] = useState<KelurahanOption[]>([]);
        const [loadingKelurahans, setLoadingKelurahans] = useState(false);
        const [selectedKecamatanCode, setSelectedKecamatanCode] = useState<string | undefined>(undefined);
        const [postalCode, setPostalCode] = useState<string>('');
        const [dataSource, setDataSource] = useState<DataType[]>([]);
        const [vatPpnValue, setVatPpnValue] = useState<number>(0);
        const [invoiceNoDatePart, setInvoiceNoDatePart] = useState<string>('');
        const [autosaveStatus, setAutosaveStatus] = useState<'idle' | 'processing' | 'error' | 'stopped'>('idle');
        const [isPrinting, setIsPrinting] = useState(false);
        const [isProcessing, setIsProcessing] = useState(false);
        const [showExportModal, setShowExportModal] = useState(false);
        const [isReportModalOpen, setIsReportModalOpen] = useState(false);
        const initialAutosaveActive = (() => {
            const storedData = localStorage.getItem('salesOrderInvoiceData');
            if (storedData) {
                const invoiceDetails = JSON.parse(storedData);
                const loadedNumericStatus = convertStatusToNumber(invoiceDetails.invoiceData.status);
                return loadedNumericStatus === 1;
            }
            return true;
        })();
        const [isAutosaveActive, setIsAutosaveActive] = useState<boolean>(initialAutosaveActive);
        const isAutosaveActiveRef = useRef<boolean>(initialAutosaveActive);
        const [serverMomentDate, setServerMomentDate] = useState<moment.Moment | null>(null);
        const [dealerReCodeDisplay, setDealerReCodeDisplay] = useState<string>('');
        const [isFormDisabled, setIsFormDisabled] = useState<boolean>(false);
        const isFirstRender = useRef(true);
        const hasLoadedInitialData = useRef(false);

        const [idTypeOptions, setIdTypeOptions] = useState<{ value: string; label: string }[]>([
            { value: "1", label: "KTP" },
            { value: "2", label: "NPWP" },
        ]);

        const vatItemCategoryValue = Form.useWatch('vat_item_category', form);
        const packingListNoValue = Form.useWatch('packing_list_no', form);
        const allFormValues = Form.useWatch([], form);
        const isPackingListNoDisabled = !vatItemCategoryValue;
        const isPackingListNoReadOnly = !!packingListNoValue;
        const isSearchPLButtonDisabled = !vatItemCategoryValue || !!packingListNoValue;

        const currentStatus = Form.useWatch('status', form);
        const isVoidDisabled = currentStatus ? ![1, 2].includes(Number(convertStatusToNumber(currentStatus))) : false;
        const isPrintDisabled = !form.getFieldValue('trans_id');

        const handleReportModalCancel = () => {
            setIsReportModalOpen(false);
        };

        useEffect(() => {
            const numericStatus = convertStatusToNumber(currentStatus);
            if (numericStatus === 1) {
                setIsAutosaveActive(true);
                isAutosaveActiveRef.current = true;
            } else {
                setIsAutosaveActive(false);
                isAutosaveActiveRef.current = false;
            }
        }, [currentStatus]);

        const saveFormData = useCallback(async () => {
            const vatItemCategory = form.getFieldValue('vat_item_category');
            const transId = form.getFieldValue('trans_id');

            if (!isAutosaveActiveRef.current || !vatItemCategory || !transId) {
                if (!isAutosaveActiveRef.current) {
                    console.log("Autosave dihentikan secara manual.");
                } else {
                    console.log("Autosave Stop");
                }
                setAutosaveStatus('stopped');
                return;
            }

            setAutosaveStatus('processing');
            try {
                const values = form.getFieldsValue(true);
                const tableData = dataSource;
                const formattedValues = {
                    ...values,
                    status: convertStatusToNumber(values.status),
                    invoice_date: values.invoice_date ? moment(values.invoice_date, "DD MMMM YYYY", 'id').format("YYYY-MM-DD") : null,
                    invoice_due_date: values.invoice_due_date ? moment(values.invoice_due_date, "DD MMMM YYYY").format("YYYY-MM-DD") : null,
                    tax_invoice_date: values.tax_invoice_date ? moment(values.tax_invoice_date, "DD MMMM YYYY", 'id').format("YYYY-MM-DD") : null,
                    npwp_date: values.npwp_date ? moment(values.npwp_date).format("YYYY-MM-DD") : null,
                    pkp_date: values.pkp_date ? moment(values.pkp_date).format("YYYY-MM-DD") : null,
                    pkp_type: checkedValue,
                    remark: values.remar,
                };
                delete formattedValues.remar;


                const numericFields = ['item_total', 'item_discount', 'total', 'dp', 'vat', 'invoice_amount'];
                numericFields.forEach(field => {
                    if (formattedValues[field]) {
                        formattedValues[field] = parseFloat(String(formattedValues[field]).replace(/\./g, '').replace(/,/g, '.'));
                    }
                });


                const itemsToSave = tableData.map(item => ({
                    ...item,
                    trans_id: transId,
                    invoice_no: form.getFieldValue('invoice_no'),
                    sales_order_no: formattedValues.sales_order_no,
                    warehouse: formattedValues.dealer_re_code,
                    price: parseFloat(String(item.price).replace(/\./g, '').replace(/,/g, '.')),
                    discount: parseFloat(String(item.discount).replace(/\./g, '').replace(/,/g, '.')),
                    total: parseFloat(String(item.total).replace(/\./g, '').replace(/,/g, '.')),
                    hpp: item.hpp,
                    ppn: item.ppn,
                }));

                const payload = {
                    invoiceData: formattedValues,
                    itemsData: itemsToSave,
                };

                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/save`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
                }

                setAutosaveStatus('idle');
            } catch (error) {
                console.error("Autosave gagal:", error);
                setAutosaveStatus('error');
            }
        }, [form, dataSource, checkedValue, vatItemCategoryValue, isAutosaveActive]);

        const debouncedSave = useCallback(debounce(saveFormData, 1000), [saveFormData]);

        const fetchAndSetServerDate = useCallback(async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/server-date`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                const serverDate = new Date(data.date);
                const momentServerDate = moment(serverDate);
                setServerMomentDate(momentServerDate);

                const day = String(serverDate.getDate()).padStart(2, '0');
                const monthName = serverDate.toLocaleDateString('id-ID', { month: 'long' });
                const yearFull = serverDate.getFullYear();
                const formattedDate = `${day} ${monthName} ${yearFull}`;


                const monthNum = String(serverDate.getMonth() + 1).padStart(2, '0');
                const yearShort = String(serverDate.getFullYear()).slice(-2);
                const formattedDateForInvoiceNo = `${monthNum}${yearShort}`;
                setInvoiceNoDatePart(formattedDateForInvoiceNo);

                form.setFieldsValue({
                    invoice_date: formattedDate,
                    tax_invoice_date: formattedDate,
                    tax_invoice_type: "Faktur Pajak Standar",
                });
                if (!form.getFieldValue('status')) {
                    form.setFieldsValue({ status: "Draft" });
                }
            } catch (error) {
                console.error("Failed to fetch server date, falling back to client date:", error);

                const today = new Date();
                const momentToday = moment(today);
                setServerMomentDate(momentToday);

                const day = String(today.getDate()).padStart(2, '0');
                const monthName = today.toLocaleDateString('id-ID', { month: 'long' });
                const yearFull = today.getFullYear();
                const formattedDate = `${day} ${monthName} ${yearFull}`;

                const monthNum = String(today.getMonth() + 1).padStart(2, '0');
                const yearShort = String(today.getFullYear()).slice(-2);
                const formattedDateForInvoiceNo = `${monthNum}${yearShort}`;
                setInvoiceNoDatePart(formattedDateForInvoiceNo);

                form.setFieldsValue({
                    invoice_date: formattedDate,
                    tax_invoice_date: formattedDate,
                    tax_invoice_type: "Faktur Pajak Standar",
                });
                if (!form.getFieldValue('status')) {
                    form.setFieldsValue({ status: "Draft" });
                }
            }
        }, [form]);

        useEffect(() => {
            if (hasLoadedInitialData.current) {
                return;
            }
            const storedData = localStorage.getItem('salesOrderInvoiceData');
            if (storedData) {
                const invoiceDetails = JSON.parse(storedData);
                const fieldsToSet: any = {
                    ...invoiceDetails.invoiceData,
                    status: convertStatusToString(invoiceDetails.invoiceData.status),
                    invoice_date: invoiceDetails.invoiceData.invoice_date ? moment(invoiceDetails.invoiceData.invoice_date, "YYYY-MM-DD").format("DD MMMM YYYY") : null,
                    invoice_due_date: invoiceDetails.invoiceData.invoice_due_date ? moment(invoiceDetails.invoiceData.invoice_due_date, "YYYY-MM-DD").format("DD MMMM YYYY") : null,
                    tax_invoice_date: invoiceDetails.invoiceData.tax_invoice_date ? moment(invoiceDetails.invoiceData.tax_invoice_date, "YYYY-MM-DD").format("DD MMMM YYYY") : null,
                    npwp_date: invoiceDetails.invoiceData.npwp_date ? moment(invoiceDetails.invoiceData.npwp_date) : undefined,
                    pkp_date: invoiceDetails.invoiceData.pkp_date ? moment(invoiceDetails.invoiceData.pkp_date) : undefined,
                    pkp_type: invoiceDetails.invoiceData.pkp_type,
                    remar: invoiceDetails.invoiceData.remark,
                };

                const numericFields = ['item_total', 'item_discount', 'total', 'dp', 'vat', 'invoice_amount'];
                const formatter = new Intl.NumberFormat('id-ID', {
                    style: 'decimal',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                numericFields.forEach(field => {
                    if (fieldsToSet[field] !== undefined && fieldsToSet[field] !== null) {
                        fieldsToSet[field] = formatter.format(parseFloat(fieldsToSet[field]));
                    }
                });

                form.setFieldsValue(fieldsToSet);
                setShowContentBillTo(!!invoiceDetails.invoiceData.customer_code);
                setShowContentTax(!!invoiceDetails.invoiceData.npwp);
                setShowContentTotal(!!invoiceDetails.invoiceData.item_total);
                setCheckedValue(invoiceDetails.invoiceData.pkp_type || null);
                setSelectedProvinceCode(invoiceDetails.invoiceData.provinsi);
                setSelectedRegencyCode(invoiceDetails.invoiceData.kabupaten);
                setSelectedKecamatanCode(invoiceDetails.invoiceData.kecamatan);
                setPostalCode(invoiceDetails.invoiceData.kode_pos || '');
                setDealerReCodeDisplay(invoiceDetails.invoiceData.dealer_re_code_label || invoiceDetails.invoiceData.dealer_re_code || '');
                setDataSource(invoiceDetails.itemsData.map((item: any) => ({
                    ...item,
                    key: item.key,
                    price: parseFloat(item.price),
                    discount: parseFloat(item.discount),
                    total: parseFloat(item.total),
                    ppn: parseFloat(item.ppn) || 0,
                })));
                localStorage.removeItem('salesOrderInvoiceData');
                hasLoadedInitialData.current = true;
            } else {
                fetchAndSetServerDate();
                hasLoadedInitialData.current = true;
            }
        }, [form, fetchAndSetServerDate])

        useEffect(() => {
            const fetchBrands = async () => {
                setLoadingBrands(true);
                try {

                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/brands`);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data: BrandOption[] = await response.json();
                    setBrandOptions(data);
                } catch (error) {
                    console.error("Failed to fetch brands:", error);

                } finally {
                    setLoadingBrands(false);
                }
            };

            fetchBrands();
        }, []);

        useEffect(() => {
            const fetchTermsOfPayment = async () => {
                setLoadingTermsOfPayment(true);
                try {
                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/terms-of-payment`);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data: TermsOfPaymentOption[] = await response.json();
                    setTermsOfPaymentOptions(data);
                } catch (error) {
                    console.error("Failed to fetch terms of payment:", error);
                } finally {
                    setLoadingTermsOfPayment(false);
                }
            };

            fetchTermsOfPayment();
        }, []);

        useEffect(() => {
            const fetchVatTransactions = async () => {
                setLoadingVatTransactions(true);
                try {
                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/vat-transactions`);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data: VatTransactionOption[] = await response.json();
                    setVatTransactionOptions(data);
                } catch (error) {
                    console.error("Failed to fetch VAT transaction codes:", error);
                } finally {
                    setLoadingVatTransactions(false);
                }
            };
            fetchVatTransactions();
        }, []);

        useEffect(() => {
            const fetchProvinces = async () => {
                setLoadingProvinces(true);
                try {
                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/provinces`);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data: ProvinceOption[] = await response.json();
                    setProvinceOptions(data);
                } catch (error) {
                    console.error("Failed to fetch provinces:", error);
                } finally {
                    setLoadingProvinces(false);
                }
            };
            fetchProvinces();
        }, []);

        useEffect(() => {
            const fetchRegencies = async () => {
                if (!selectedProvinceCode) {
                    setRegencyOptions([]);
                    return;
                }

                setLoadingRegencies(true);
                try {
                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/regencies/${selectedProvinceCode}`);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data: RegencyOption[] = await response.json();
                    setRegencyOptions(data);
                } catch (error) {
                    console.error("Failed to fetch regencies:", error);
                    setRegencyOptions([]);
                } finally {
                    setLoadingRegencies(false);
                }
            };
            fetchRegencies();
        }, [selectedProvinceCode])

        useEffect(() => {
            const fetchKecamatans = async () => {
                if (!selectedRegencyCode) {
                    setKecamatanOptions([]);
                    return;
                }
                setLoadingKecamatans(true);
                try {
                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/kecamatans/${selectedRegencyCode}`);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data: KecamatanOption[] = await response.json();
                    setKecamatanOptions(data);
                } catch (error) {
                    console.error("Failed to fetch kecamatans:", error);
                    setKecamatanOptions([]);
                } finally {
                    setLoadingKecamatans(false);
                }
            };
            fetchKecamatans();
        }, [selectedRegencyCode]);

        useEffect(() => {
            const fetchKelurahans = async () => {
                if (!selectedKecamatanCode) {
                    setKelurahanOptions([]);
                    return;
                }
                setLoadingKelurahans(true);
                try {
                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/kelurahans/${selectedKecamatanCode}`);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data: KelurahanOption[] = await response.json();
                    setKelurahanOptions(data);
                } catch (error) {
                    console.error("Failed to fetch kelurahans:", error);
                    setKelurahanOptions([]);
                } finally {
                    setLoadingKelurahans(false);
                }
            };
            fetchKelurahans();
        }, [selectedKecamatanCode]);

        useEffect(() => {
            const fetchVatPpnRate = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/vat-ppn-rate`);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data = await response.json();
                    setVatPpnValue(data.value_ppn);
                } catch (error) {
                    console.error("Failed to fetch VAT PPN rate:", error);
                }
            };
            fetchVatPpnRate();
        }, []);

        useEffect(() => {
            let calculatedItemTotal = 0;
            let calculatedItemDiscount = 0;

            const itemsToCalculate = dataSource.filter(item => item.status_part !== '99');

            itemsToCalculate.forEach(item => {
                calculatedItemTotal += (item.price || 0) * (item.qty || 0);
                calculatedItemDiscount += (item.discount || 0) * (item.qty || 0);
            });
            const calculatedTotal = calculatedItemTotal - calculatedItemDiscount;
            const calculatedVat = calculatedTotal * (vatPpnValue / 100);
            const calculatedInvoiceAmount = calculatedTotal + calculatedVat;

            const formatter = new Intl.NumberFormat('id-ID', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            form.setFieldsValue({
                item_total: formatter.format(calculatedItemTotal),
                item_discount: formatter.format(calculatedItemDiscount),
                total: formatter.format(calculatedTotal),
                vat: formatter.format(calculatedVat),
                invoice_amount: formatter.format(calculatedInvoiceAmount),
            });
        }, [dataSource, vatPpnValue, form]);

        const handleCheckboxChange = (value: string) => {
            setCheckedValue((prevValue) => (prevValue === value ? null : value));
        };

        const onDateChange: DatePickerProps['onChange'] = (date, dateString) => {
            console.log("Selected Date: ", dateString);
        };

        const onChangeGeneric = useCallback((value: string) => {
            console.log(`Selected: ${value}`);
        }, []);

        const onChangeVatItemCategory = useCallback((value: string) => {
            console.log(`Selected VAT Item Category: ${value}`);
        }, [form, invoiceNoDatePart]);

        const onChangeProvince = useCallback((value: string) => {
            setSelectedProvinceCode(value);
            setSelectedRegencyCode(undefined);
            setRegencyOptions([]);
            setKecamatanOptions([]);
            setSelectedKecamatanCode(undefined);
            setKelurahanOptions([]);
            setPostalCode('');
            form.setFieldsValue({ kode_pos: '' });
            console.log(`Selected Province: ${value}`);
        }, [form]);

        const onChangeRegency = useCallback((value: string) => {
            setSelectedRegencyCode(value);
            setKecamatanOptions([]);
            setSelectedKecamatanCode(undefined);
            setKelurahanOptions([]);
            setPostalCode('');
            form.setFieldsValue({ kode_pos: '' });
            console.log(`Selected Regency: ${value}`);
        }, [form]);

        const onChangeKecamatan = useCallback((value: string) => {
            setSelectedKecamatanCode(value);
            setKelurahanOptions([]);
            setPostalCode('');
            form.setFieldsValue({ kode_pos: '' });
            console.log(`Selected Kecamatan: ${value}`);
        }, [form]);

        const onChangeKelurahan = useCallback(async (value: string) => {
            console.log(`Selected Kelurahan: ${value}`);

            if (value) {
                try {
                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/postal-code/${value}`);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data = await response.json();
                    setPostalCode(data.postalCode || '');
                    form.setFieldsValue({ kode_pos: data.postalCode || '' });
                } catch (error) {
                    console.error("Failed to fetch postal code:", error);
                    setPostalCode('');
                    form.setFieldsValue({ kode_pos: '' });
                }
            } else {
                setPostalCode('');
                form.setFieldsValue({ kode_pos: '' });
            }
        }, [form]);

        const onChangeTermsOfPayment = useCallback((value: string) => {
            console.log(`Selected Terms of Payment: ${value}`);
            const invoiceDateString = form.getFieldValue('invoice_date');
            if (invoiceDateString) {
                const invoiceDate = moment(invoiceDateString, "DD MMMM YYYY");
                const match = value.match(/\d+/);
                const daysToAdd = match ? parseInt(match[0], 10) : 0;

                if (invoiceDate.isValid() && daysToAdd > 0) {
                    const dueDate = invoiceDate.add(daysToAdd, 'days');
                    form.setFieldsValue({ invoice_due_date: dueDate.format("DD MMMM YYYY") });
                } else {
                    form.setFieldsValue({ invoice_due_date: '' });
                }
            } else {
                form.setFieldsValue({ invoice_due_date: '' });
            }
        }, [form]);

        const onSelectCustomer = useCallback((customer: CustomerDataType) => {
            setShowCustomerModal(false);
            setShowContentBillTo(true);
            setShowContentTax(true);

            const addressBill = [customer.address_line1, customer.address_line2]
                .filter(Boolean)
                .join(' | ');

            const addressTax = [customer.vat_address1, customer.vat_address2]
                .filter(Boolean)
                .join(' | ');


            const isPKPNumeric = customer.vatpkp && !isNaN(Number(customer.vatpkp));
            setCheckedValue(isPKPNumeric ? "Yes" : "No");

            form.setFieldsValue({
                customer_code: customer.cs_code,
                customer_type: customer.customer_type,
                title_prefix: customer.title_p,
                name_bill: customer.cs_name,
                title_suffix: customer.title_s,
                id_type: customer.id_type,
                id_no: customer.id_no,
                billable_to: "6",
                address: addressBill,
                provinsi: customer.vatprovinsi,
                kabupaten: customer.vatkabupaten,
                kecamatan: customer.vatkecamatan,
                kelurahan: customer.vatkelurahan,
                kode_pos: customer.vatkodepos,
                npwp: customer.vatnpwp,
                npwp_date: customer.vatnpwpdate ? moment(customer.vatnpwpdate) : undefined,
                pkp: customer.vatpkp,
                pkp_date: customer.vatpkpdate ? moment(customer.vatpkpdate) : undefined,
                trasaction_code: customer.vattransactioncode,
                name_tax: customer.vatname,
                address_tax: addressTax,
            });

            setSelectedProvinceCode(customer.vatprovinsi);
            setSelectedRegencyCode(customer.vatkabupaten);
            setSelectedKecamatanCode(customer.vatkecamatan);
            setPostalCode(customer.vatkodepos || '');

            console.log("Selected Customer Data:", customer);
        }, [form, setShowCustomerModal, setShowContentBillTo, setShowContentTax]);

        const onSelectPackingList = useCallback(async (data: PackingListData, items: PackingListItem[]) => {
            setShowPackingListModal(false);
            setShowContentBillTo(true);
            setShowContentTax(true);


            setCheckedValue(data.pkp ? "Yes" : "No");

            form.setFieldsValue({
                trans_id: data.trans_id,
                packing_list_no: data.packing_list_no,
                profit_center: "Spareparts",
                dealer_re_code: data.dealer_re_code,
                transaction_type: data.transaction_type,
                event_no: "01",
                customer: data.customer,
                sales_man: data.sales_man,
                po_customer_no: data.po_customer_no,
                sales_order_no: data.sales_order_no,
                payment_type: data.payment_type,
                customer_code: data.customer_code,
                customer_type: data.customer_type,
                title_prefix: data.title_prefix,
                name_bill: data.name_bill,
                title_suffix: data.title_suffix,
                id_type: data.id_type,
                id_no: data.id_no,
                billable_to: "6",
                address: data.address,
                provinsi: data.provinsi,
                kabupaten: data.kabupaten,
                kecamatan: data.kecamatan,
                kelurahan: data.kelurahan,
                kode_pos: data.postal_code,
                phone_no: data.phone_no,
                top: data.top,
                bill_code: "Pihak ke - 3",
                tax_invoice_type: "Faktur Pajak Standar",
                npwp: data.npwp,
                npwp_date: data.npwp_date ? moment(data.npwp_date) : undefined,
                pkp: data.pkp,
                pkp_date: data.pkp_date ? moment(data.pkp_date) : undefined,
                transaction_code: data.transaction_code,
                name_tax: data.name_tax,
                address_tax: data.address_tax,
            });
            setDealerReCodeDisplay(data.dealer_re_code_label || '');

            if (data.top) {
                onChangeTermsOfPayment(data.top);
            }

            setSelectedProvinceCode(data.provinsi);
            setSelectedRegencyCode(data.kabupaten);
            setSelectedKecamatanCode(data.kecamatan);
            setPostalCode(data.postal_code || '');
            setDataSource(items);
        }, [form, setShowPackingListModal, setShowContentBillTo, setShowContentTax, onChangeTermsOfPayment]);


        const rowSelection: TableProps<DataType>["rowSelection"] = {
            selectedRowKeys,
            onChange: (newSelectedRowKeys) => setSelectedRowKeys(newSelectedRowKeys),
        };

        const handleVoid = useCallback(() => {
            const transId = form.getFieldValue('trans_id');
            const statusNum = Number(convertStatusToNumber(form.getFieldValue('status')));
            const invDateStr = form.getFieldValue('invoice_date');

            if (!transId) {
                notification.warning({ message: 'Invoice No. harus diisi untuk melakukan Void.', duration: 5 });
                return;
            }

            if (statusNum === 2) {
                const invMoment = moment(invDateStr, "DD MMMM YYYY", 'id');
                const currentMoment = serverMomentDate || moment();

                if (invMoment.format('YYYY-MM') !== currentMoment.format('YYYY-MM')) {
                    Modal.error({
                        title: <span style={{ color: '#ff4d4f' }}>Peringatan</span>,
                        content: 'Invoice tidak dapat di void karena beda bulan, hubungi Administrator',
                        okButtonProps: { danger: true },
                    });
                    return;
                }
                Modal.confirm({
                    title: 'Konfirmasi Peringatan',
                    content: 'Apakah anda yakin membatalkan invoice ?',
                    onOk: () => {
                        setIsReasonModalOpen(true);
                    }
                });
                return;
            }

            Modal.confirm({
                title: 'Konfirmasi Void',
                content: `Tindakan ini akan menghapus Trans ID ${transId}? yang masih berstatus Draft dari sistem...`,
                okText: 'Ya, Void',
                okType: 'danger',
                cancelText: 'Batal',
                onOk: async () => {
                    setIsProcessing(true);
                    try {
                        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/void`, {
                            method: 'DELETE',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ trans_id: transId }),
                        });

                        if (!response.ok) {
                            const errorData = await response.json();
                            throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
                        }
                        notification.success({ message: `Invoice No. ${transId} berhasil dibatalkan.`, duration: 5 });
                        form.resetFields();
                        setDataSource([]);
                        setShowContentBillTo(false);
                        setShowContentTotal(false);
                        setShowContentTax(false);
                        setCheckedValue(null);
                        setSelectedRowKeys([]);
                        setSelectedProvinceCode(undefined);
                        setSelectedRegencyCode(undefined);
                        setSelectedKecamatanCode(undefined);
                        setPostalCode('');
                        setRegencyOptions([]);
                        setKecamatanOptions([]);
                        setKelurahanOptions([]);
                        setAutosaveStatus('idle');
                        hasLoadedInitialData.current = false;
                        fetchAndSetServerDate();
                    } catch (error: any) {
                        console.error("Gagal membatalkan invoice:", error);
                        notification.error({ message: `Gagal membatalkan invoice: ${error.message}`, duration: 5 });
                        setAutosaveStatus('error');
                    } finally {
                        setIsProcessing(false);
                    }
                },
            });
        }, [form, fetchAndSetServerDate]);

        const handleRefreshData = useCallback(async () => {
            const statusNum = Number(convertStatusToNumber(form.getFieldValue('status')));
            if (statusNum !== 1) {
                return;
            }
            const packingListNo = form.getFieldValue('packing_list_no');
            if (!packingListNo) {
                return;
            }
            setIsProcessing(true);
            try {
                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/import-packing-list/${encodeURIComponent(packingListNo)}?skipCheckDuplicate=true`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                });
                if (!response.ok) {
                    const errData = await response.json();
                    throw new Error(errData.message || `HTTP error! status: ${response.status}`);
                }
                const { headerData, itemsData } = await response.json();
                form.setFieldsValue({
                    packing_list_no: headerData.packing_list_no,
                    profit_center: headerData.profit_center,
                    dealer_re_code: headerData.dealer_re_code,
                    transaction_type: headerData.transaction_type,
                    event_no: headerData.event_no,
                    customer: headerData.customer,
                    sales_man: headerData.sales_man,
                    po_customer_no: headerData.po_customer_no,
                    sales_order_no: headerData.sales_order_no,
                    payment_type: headerData.payment_type,
                    customer_code: headerData.customer_code,
                    customer_type: headerData.customer_type,
                    title_prefix: headerData.title_prefix,
                    name_bill: headerData.name_bill,
                    title_suffix: headerData.title_suffix,
                    id_type: headerData.id_type,
                    id_no: headerData.id_no,
                    billable_to: headerData.billable_to,
                    address: headerData.address,
                    provinsi: headerData.provinsi,
                    kabupaten: headerData.kabupaten,
                    kecamatan: headerData.kecamatan,
                    kelurahan: headerData.kelurahan,
                    kode_pos: headerData.postal_code,
                    phone_no: headerData.phone_no,
                    top: headerData.top,
                    bill_code: headerData.bill_code,
                    tax_invoice_type: headerData.tax_invoice_type,
                    npwp: headerData.npwp,
                    npwp_date: headerData.npwp_date ? moment(headerData.npwp_date) : undefined,
                    pkp: headerData.pkp,
                    pkp_date: headerData.pkp_date ? moment(headerData.pkp_date) : undefined,
                    transaction_code: headerData.transaction_code,
                    name_tax: headerData.name_tax,
                    address_tax: headerData.address_tax,
                });
                setDealerReCodeDisplay(headerData.dealer_re_code_label || '');
                setCheckedValue(headerData.pkp ? "Yes" : "No");
                setSelectedProvinceCode(headerData.provinsi);
                setSelectedRegencyCode(headerData.kabupaten);
                setSelectedKecamatanCode(headerData.kecamatan);
                setPostalCode(headerData.postal_code || '');
                if (headerData.top) {
                    onChangeTermsOfPayment(headerData.top);
                }
                setDataSource(itemsData);
                setShowContentBillTo(true);
                setShowContentTax(true);
                notification.success({ message: 'Data berhasil direfresh!', duration: 3 });
            } catch (error: any) {
                console.error("Gagal refresh data packing list:", error);
                notification.error({ message: `Gagal refresh data: ${error.message}`, duration: 5 });
            } finally {
                setIsProcessing(false);
            }
        }, [form, onChangeTermsOfPayment]);

        const handleReasonSubmit = async () => {
            setIsProcessing(true);
            try {
                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/request-void`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        trans_id: form.getFieldValue('trans_id'),
                        status: "3",
                        close_invoice_sales_order: "1",
                        code: "01",
                        request_by: userData?.kode_grup1 || '',
                        date_request: moment().format("YYYY-MM-DD HH:mm:ss"),
                        no_document: form.getFieldValue('invoice_no'),
                        warehouse: form.getFieldValue('dealer_re_code'),
                        amount: parseFloat(String(form.getFieldValue('total')).replace(/\./g, '').replace(/,/g, '.')) || 0,
                        remark: voidReason
                    })
                });
                if (!response.ok) {
                    throw new Error('Gagal memproses request void.');
                }
                notification.success({ message: `Request Void untuk Invoice ${form.getFieldValue('invoice_no')} berhasil dikirim.`, duration: 5 });
                setIsReasonModalOpen(false);
                handleNew();
            } catch (error: any) {
                notification.error({ message: `Gagal mengajukan void: ${error.message}`, duration: 5 });
            } finally {
                setIsProcessing(false);
            }
        };

        const handleNew = useCallback(() => {
            form.resetFields();
            setDataSource([]);
            setShowContentBillTo(false);
            setShowContentTotal(false);
            setShowContentTax(false);
            setCheckedValue(null);
            setSelectedRowKeys([]);
            setSelectedProvinceCode(undefined);
            setSelectedRegencyCode(undefined);
            setSelectedKecamatanCode(undefined);
            setPostalCode('');
            setRegencyOptions([]);
            setKecamatanOptions([]);
            setKelurahanOptions([]);
            setDealerReCodeDisplay('');
            setIsFormDisabled(false);
            setAutosaveStatus('idle');
            hasLoadedInitialData.current = false;
            fetchAndSetServerDate();
        }, [form, fetchAndSetServerDate]);

        const handleSubmit = useCallback(async () => {
            const requiredFields = ['brand', 'vat_item_category', 'event_no'];
            const emptyRequiredFields = requiredFields.filter(field => {
                const value = form.getFieldValue(field);
                return value === undefined || value === null || value === '';
            });

            const executeSubmit = async () => {
                setIsProcessing(true);
                isAutosaveActiveRef.current = false;
                setIsAutosaveActive(false);
                try {

                    setAutosaveStatus('processing');

                    const values = form.getFieldsValue(true);
                    const tableData = dataSource;
                    const formattedValues = {
                        ...values,
                        invoice_no: values.invoice_no || null,
                        status: convertStatusToNumber('Active'),
                        invoice_date: values.invoice_date ? moment(values.invoice_date, "DD MMMM YYYY", 'id').format("YYYY-MM-DD") : null,
                        invoice_due_date: values.invoice_due_date ? moment(values.invoice_due_date, "DD MMMM YYYY").format("YYYY-MM-DD") : null,
                        tax_invoice_date: values.tax_invoice_date ? moment(values.tax_invoice_date, "DD MMMM YYYY", 'id').format("YYYY-MM-DD") : null,
                        npwp_date: values.npwp_date ? moment(values.npwp_date).format("YYYY-MM-DD") : undefined,
                        pkp_date: values.pkp_date ? moment(values.pkp_date).format("YYYY-MM-DD") : undefined,
                        pkp_type: checkedValue,
                        remark: values.remar,
                    };
                    delete formattedValues.remar;

                    const numericFields = ['item_total', 'item_discount', 'total', 'dp', 'vat', 'invoice_amount'];
                    numericFields.forEach(field => {
                        if (formattedValues[field]) {
                            formattedValues[field] = parseFloat(String(formattedValues[field]).replace(/\./g, '').replace(/,/g, '.'));
                        }
                    });

                    const itemsToSave = tableData.map(item => ({
                        ...item,
                        invoice_no: formattedValues.invoice_no,
                        trans_id: form.getFieldValue('trans_id'),
                        sales_order_no: formattedValues.sales_order_no,
                        warehouse: formattedValues.dealer_re_code,
                        price: parseFloat(String(item.price).replace(/\./g, '').replace(/,/g, '.')),
                        discount: parseFloat(String(item.discount).replace(/\./g, '').replace(/,/g, '.')),
                        total: parseFloat(String(item.total).replace(/\./g, '').replace(/,/g, '.')),
                        hpp: item.hpp,
                        ppn: item.ppn,
                    }));

                    const payload = {
                        invoiceData: formattedValues,
                        itemsData: itemsToSave,
                    };

                    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/save`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(payload),
                    });

                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
                    }

                    const result = await response.json();
                    const finalInvoiceNo = result.invoice_no || values.invoice_no;
                    form.setFieldsValue({ invoice_no: finalInvoiceNo, status: convertStatusToString('Active') });
                    notification.success({ message: 'Success', duration: 5 });
                    setDataSource(tableData.map(item => ({ ...item, invoice_no: finalInvoiceNo })));
                    setAutosaveStatus('stopped');
                    setIsFormDisabled(true);
                    isAutosaveActiveRef.current = false;
                    setIsAutosaveActive(false);
                } catch (error: any) {
                    console.error("Gagal submit invoice:", error);
                    const errorMsg = error.message || '';
                    if (errorMsg.includes('SO telah di batalkan tidak dapat memproses invoice')) {
                        Modal.warning({
                            title: 'SO Tidak Dapat Diproses',
                            content: 'SO telah di batalkan tidak dapat memproses invoice, silahkan lakukan void !',
                        });
                    } else if (errorMsg.includes('SO tidak dapat di proses invoice')) {
                        Modal.warning({
                            title: 'SO Telah Dibatalkan',
                            content: 'SO tidak dapat di proses invoice, silahkan cek status data SO !',
                        });
                    } else if (errorMsg.includes('sudah terdaftar di database')) {
                        notification.error({
                            message: "Duplicate Data ! Error Insert",
                            description: errorMsg,
                            style: { background: '#fff2f0', border: '1px solid #ffccc7' },
                            duration: 5,
                        });
                    } else {
                        notification.error({ message: `Gagal memeriksa status Sales Order: ${error.message}`, duration: 5 });
                    }
                    setAutosaveStatus('error');
                    isAutosaveActiveRef.current = true;
                    setIsAutosaveActive(true);
                } finally {
                    setIsProcessing(false);
                }
            };

            if (emptyRequiredFields.length > 0) {
                form.scrollToField(emptyRequiredFields[0], { focus: true });
                return;
            }
            Modal.confirm({
                title: 'Konfirmasi',
                content: 'Apakah data sesuai? Proses ini tidak dapat di batalkan',
                okText: 'Ya',
                cancelText: 'Tidak',
                onOk: async () => {
                    await executeSubmit();
                }
            });
        }, [form, dataSource, checkedValue]);

        const handlePrint = useCallback(async () => {
            const transId = form.getFieldValue('trans_id');
            const status = form.getFieldValue('status');
            const numericStatus = convertStatusToNumber(status);

            if (!transId) {
                notification.warning({ message: 'Trans ID. harus diisi sebelum mencetak.', duration: 5 });
                return;
            }

            if (numericStatus === 6) {
                notification.warning({ message: 'Invoice Tidak bisa di print karena Closed Return', duration: 5 });
                return;
            }

            if (numericStatus !== 2 && numericStatus !== 1) {
                notification.warning({
                    message: 'Invoice hanya bisa dicetak jika statusnya Active atau Draft.',
                    duration: 5
                });
                return;
            }
            setIsProcessing(true);
            setIsPrinting(true);

            try {

                const logPrintResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/log-print`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ trans_id: transId }),
                });

                if (!logPrintResponse.ok) {
                    notification.warning({ message: 'Gagal mencatat riwayat cetak. Watermark mungkin tidak akurat.', duration: 5 });
                }
                const logPrintData = await logPrintResponse.json();
                const newPrintCount = logPrintData.count || 1;

                const detailsResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/details/${transId}`);
                if (!detailsResponse.ok) {
                    throw new Error(`Failed to fetch invoice details: ${detailsResponse.statusText}`);
                }
                const { invoiceData, itemsData }: { invoiceData: InvoiceDetailsData, itemsData: DataType[] } = await detailsResponse.json();

                let salesDate = invoiceData.sales_date || "";
                const targetSoNo = invoiceData.sales_order_no || form.getFieldValue('sales_order_no');
                if (targetSoNo) {
                    try {
                        const soResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/so-invoice/check-so-status/${encodeURIComponent(targetSoNo)}`);
                        if (soResponse.ok) {
                            const soData = await soResponse.json();
                            if (soData && soData.sales_date) {
                                salesDate = soData.sales_date;
                            }
                        }
                    } catch (err) {
                        console.error("Failed to fetch sales_date from sales_master:", err);
                    }
                }

                const reportPayload = {
                    Header: [{
                        trans_id: invoiceData.trans_id || "",
                        invoice_no: invoiceData.invoice_no || "",
                        invoice_date: formatToIndonesianDate(invoiceData.invoice_date),
                        invoice_due_date: formatToIndonesianDate(invoiceData.invoice_due_date),
                        tax_invoice_no: invoiceData.tax_invoice_no || "",
                        tax_invoice_date: formatToIndonesianDate(invoiceData.tax_invoice_date),
                        sales_order_no: invoiceData.sales_order_no || "",
                        sales_order_date: formatToIndonesianDate(salesDate),
                        transaction_type: invoiceData.transaction_type || "",
                        po_customer_no: invoiceData.po_customer_no || "",
                        sales_man: invoiceData.sales_man || "",
                        name_bill: invoiceData.name_bill || "",
                        address: invoiceData.address || "",
                        phone_no: invoiceData.phone_no || "",
                        npwp: invoiceData.npwp || "",
                        dealer_re_code: invoiceData.dealer_re_code || "",
                        top_description: invoiceData.top_description || "",
                        remark: invoiceData.remark || "",
                        item_total: Number(invoiceData.item_total) || 0,
                        item_discount: Number(invoiceData.item_discount) || 0,
                        total: Number(invoiceData.total) || 0,
                        vat: Number(invoiceData.vat) || 0,
                        invoice_amount: Number(invoiceData.invoice_amount) || 0,
                        terbilang: numberToWordsID(Number(invoiceData.invoice_amount)) || "",
                    }],
                    Details: itemsData.map((item: any, index: number) => ({
                        row_no: index + 1,
                        item_code: item.item_code || "",
                        item_name: item.item_name || "",
                        qty: Number(item.qty) || 0,
                        uom: item.uom || "",
                        price: Number(item.price) || 0,
                        disc_percent: Number(item.disc_percent) || 0,
                        discount: Number(item.discount) || 0,
                        total: Number(item.total) || 0
                    }))
                };
                 await import("stimulsoft-reports-js/Css/stimulsoft.viewer.office2013.whiteblue.css"); 
                await import("stimulsoft-reports-js/Scripts/stimulsoft.reports"); 
                const viewerModule = await import("stimulsoft-reports-js/Scripts/stimulsoft.viewer"); 
                const Stimulsoft = viewerModule.Stimulsoft || (window as any).Stimulsoft; 
                StartLicense(Stimulsoft);
                setIsReportModalOpen(true);
                setTimeout(() => {
                    const report = Stimulsoft.Report.StiReport.createNewReport();
                    report.loadFile("/reports/SOIV/sales_order_invoice.mrt");
                    const dataSet = new Stimulsoft.System.Data.DataSet("ReportData");
                    dataSet.readJson(reportPayload);
                    report.regData(dataSet.dataSetName, "", dataSet);
                    report.dictionary.synchronize();
                    const options = new Stimulsoft.Viewer.StiViewerOptions();
                    options.toolbar.showOpenButton = true;
                    const viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
                    (viewer as any).onOpenReport = (args: any) => {
                        const newReport = args.report;
                        if (newReport) {
                            newReport.regData(dataSet.dataSetName, "", dataSet);
                            newReport.dictionary.synchronize();
                            viewer.report = newReport;
                        }
                    };
                    viewer.report = report;
                    viewer.renderHtml("sti-viewer-container");
                }, 300);

            } catch (error: any) {
                console.error("Gagal mencetak invoice:", error);
                notification.error({ message: `Gagal mencetak invoice: ${error.message}`, duration: 5 });
            } finally {
                setIsPrinting(false);
                setIsProcessing(false);
            }
        }, [form]);

        useEffect(() => {
            if (isFirstRender.current) {
                isFirstRender.current = false;
                return;
            }
            if (isAutosaveActive) {
                debouncedSave();
            } else {
                setAutosaveStatus('stopped');
            }
        }, [dataSource, debouncedSave, allFormValues, isAutosaveActive]);

        return (
            <WrappedComponent
                {...(props as P)}
                transformStyle={transformStyle}
                showContentBillTo={showContentBillTo}
                setShowContentBillTo={setShowContentBillTo}
                showContentTotal={showContentTotal}
                setShowContentTotal={setShowContentTotal}
                showContentTax={showContentTax}
                setShowContentTax={setShowContentTax}
                checkedValue={checkedValue}
                handleCheckboxChange={handleCheckboxChange}
                onDateChange={onDateChange}
                onChange={onChangeGeneric}
                onChangeProvince={onChangeProvince}
                onChangeVatItemCategory={onChangeVatItemCategory}
                columns={columns}
                rowSelection={rowSelection}
                dataSource={dataSource}
                initialStatus={form.getFieldValue('status') || "Draft"}
                brandOptions={brandOptions}
                loadingBrands={loadingBrands}
                termsOfPaymentOptions={termsOfPaymentOptions}
                loadingTermsOfPayment={loadingTermsOfPayment}
                vatTransactionOptions={vatTransactionOptions}
                loadingVatTransactions={loadingVatTransactions}
                showPackingListModal={showPackingListModal}
                setShowPackingListModal={setShowPackingListModal}
                showCustomerModal={showCustomerModal}
                setShowCustomerModal={setShowCustomerModal}
                provinceOptions={provinceOptions}
                loadingProvinces={loadingProvinces}
                regencyOptions={regencyOptions}
                loadingRegencies={loadingRegencies}
                selectedProvinceCode={selectedProvinceCode}
                kecamatanOptions={kecamatanOptions}
                loadingKecamatans={loadingKecamatans}
                selectedRegencyCode={selectedRegencyCode}
                onChangeRegency={onChangeRegency}
                kelurahanOptions={kelurahanOptions}
                loadingKelurahans={loadingKelurahans}
                selectedKecamatanCode={selectedKecamatanCode}
                onChangeKecamatan={onChangeKecamatan}
                postalCode={postalCode}
                onChangeKelurahan={onChangeKelurahan}
                form={form}
                onSelectCustomer={onSelectCustomer}
                onSelectPackingList={onSelectPackingList}
                onChangeTermsOfPayment={onChangeTermsOfPayment}
                isPackingListNoDisabled={isPackingListNoDisabled}
                isPackingListNoReadOnly={isPackingListNoReadOnly}
                isSearchPLButtonDisabled={isSearchPLButtonDisabled}
                isVoidDisabled={isVoidDisabled}
                autosaveStatus={autosaveStatus}
                onVoid={handleVoid}
                voidReason={voidReason}
                setVoidReason={setVoidReason}
                isReasonModalOpen={isReasonModalOpen}
                setIsReasonModalOpen={setIsReasonModalOpen}
                handleReasonSubmit={handleReasonSubmit}
                onSubmit={handleSubmit}
                onPrint={handlePrint}
                isPrinting={isPrinting}
                isProcessing={isProcessing}
                dealerReCodeDisplay={dealerReCodeDisplay}
                isFormDisabled={isFormDisabled}
                onNew={handleNew}
                onRefreshData={handleRefreshData}
                isPrintDisabled={isPrintDisabled}
                isReportModalOpen={isReportModalOpen}
                handleReportModalCancel={handleReportModalCancel}
            />
        );
    };
    return HOCComponent;
};

export default withSalesOrderInvoiceLogic;